import useCurrentProfile from './useCurrentProfile';

const useIsApplicationsAvailable = () => {
  const profile = useCurrentProfile();
  const hasFeature = profile?.features?.veengu_business_applications;
  return hasFeature;
};

export default useIsApplicationsAvailable;
